export default __webpack_public_path__ + "static/media/damage-maps.3783a6bb.svg";